var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 50,
    height: 50,
    rx: 5,
    fill: "#EAEBEC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_240_557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2938 17.1075C35.8338 15.6137 34.3863 14.1662 32.8926 14.7075L14.6363 21.31C13.1376 21.8525 12.9563 23.8975 14.3351 24.6962L20.1626 28.07L25.3663 22.8662C25.6021 22.6385 25.9178 22.5126 26.2456 22.5154C26.5733 22.5182 26.8868 22.6497 27.1186 22.8815C27.3503 23.1132 27.4818 23.4267 27.4846 23.7545C27.4875 24.0822 27.3615 24.398 27.1338 24.6337L21.9301 29.8375L25.3051 35.665C26.1026 37.0437 28.1476 36.8612 28.6901 35.3637L35.2938 17.1075Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_240_557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteIcon);
export default __webpack_public_path__ + "static/media/invite-icon.2fdc01a3426c04819af250ed4bd844e0.svg";
export { ForwardRef as ReactComponent };